import { render, staticRenderFns } from "./ReservationCancelled.vue?vue&type=template&id=1b7c4627&"
import script from "./ReservationCancelled.vue?vue&type=script&lang=js&"
export * from "./ReservationCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7c4627')) {
      api.createRecord('1b7c4627', component.options)
    } else {
      api.reload('1b7c4627', component.options)
    }
    module.hot.accept("./ReservationCancelled.vue?vue&type=template&id=1b7c4627&", function () {
      api.rerender('1b7c4627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ReservationCancelled.vue"
export default component.exports